// TODO: close (or move...) the dropdown when resizing window
window._define('autocomplete-search', ['jquery', 'widgets/autocompletefield'], function ($, Autocomplete) { 'use strict';

    return {

        init: function () {
            this.initSearch();
        },

        initSearch: function () {
            var $containers = $('.js-autocomplete-course-search'),

                resultHtml = '<a href="/courses/<%= slug %>">' +
                             '    <% if (typeof illustration !== "undefined") { %>' +
                             '        <img height="30" src="<%= illustration %>"/>' +
                             '    <% } else { %>' +
                             '        <span class="course-fake-img"></span>' +
                             '    <% } %>' +
                             '    <span class="course-title"><%- title %></span>' +
                             '</a>';

            $containers.each(function (n, element) {
                var options = {
                    dataMap: { label: 'title', value: 'title' },
                    minLength: 3,
                    appendTo: $(element),
                    itemTemplate: resultHtml,
                    select: function (event, ui) {
                        event.stopPropagation();
                        window.location.href = '/courses/' + ui.item.slug;
                    },
                };

                new Autocomplete(options, $('input', element));
            });
        },
    };
});

